/* eslint-disable no-nested-ternary */
import React from 'react';
import LinearLoader from '../../cosmetics/linearLoader/LinearLoader';
import './Page.scss';
import PageBroken from './pageBroken/PageBroken';
const Page = ({ children, className, dashboard, dark, loading, failed, onClick }) => loading ? (React.createElement(LinearLoader, null)) : failed ? (React.createElement(PageBroken, null)) : (React.createElement("div", { onClick: onClick, className: `page-container ${className || ''} ${dashboard ? 'dashboard' : ''} ${dark ? 'dark' : ''}` }, children));
export default Page;
